import { ChangeDetectionStrategy, Component, Inject, OnInit, Signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { API_CONFIGURATION, FullApiClientConfiguration, RootParams } from '@ftr/api-shared'
import { IdentityProviderName } from '@ftr/contracts/type/account'
import { NAVIGATION_SHELL, NavigationShell } from '@ftr/routing-paths'
import { CoreParams } from './core.params'

@Component({
  selector: 'ftr-login-page',
  template: `<ftr-login
    [returnUrl]="returnUrl"
    [identityProvider]="identityProvider"
    [codeChallenge]="codeChallenge"
    [state]="state"
    [showMockLogin]="showMockLogin"
    [bordered]="bordered"
  />`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginPage implements OnInit {
  returnUrl: string | undefined

  identityProvider: IdentityProviderName | undefined
  codeChallenge: string | undefined
  state: string | undefined

  showMockLogin: boolean

  readonly bordered: boolean

  constructor(
    private route: ActivatedRoute,
    @Inject(API_CONFIGURATION) private readonly configurationService: FullApiClientConfiguration,
    @Inject(NAVIGATION_SHELL) navigationShell: Signal<NavigationShell>,
  ) {
    this.bordered = navigationShell() === 'redesign'
  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams[RootParams.ReturnUrl]

    this.identityProvider = this.route.snapshot.queryParams[RootParams.IdentityProvider]
    this.codeChallenge = this.route.snapshot.queryParams[RootParams.CodeChallenge]
    this.state = this.route.snapshot.queryParams[RootParams.State]

    this.showMockLogin =
      this.route.snapshot.queryParams[CoreParams.Mock] === 'true' && !!this.configurationService.mockAuthUrl
  }
}
